
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class LanguageSelector extends Vue {
    change(lang: string): void {
        localStorage.setItem('lang', lang);
        this.$i18n.locale = lang;
    }
}
